import { render } from "./App.vue?vue&type=template&id=2f552a52"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2f552a52&lang=scss"
import "./App.vue?vue&type=style&index=1&id=2f552a52&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=2&lang=css&external"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__